import { Component, OnChanges, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';

export interface IFilterOption {
  value: any;
  displayText: string;
  class: string;
}

// TODO: Refactorizar haciendo obligatorio el uso del tagID? O crear otro modelo distinto para expansor-multiple
export interface ISelectedValue {
  value: any;
  categoryName: string;
  viewValue: any;
  tagID?: number;
}

@Component({
  selector: 'app-expansor-with-search-date',
  templateUrl: './expansor-with-search-date.component.html',
  styleUrls: ['./expansor-with-search-date.component.scss']
})
export class ExpansorWithSearchDateComponent implements OnChanges {

  @Input() expanded = false;
  @Input() hideDivider = false;
  @Input() placeHolderText = '';
  @Input() categoryName = '';
  @Output() filterChangeEvent = new EventEmitter<ISelectedValue>();
  filterValue: IFilterOption = {value: '', displayText: '', class: ''};
  date: any;

  @Input() set selectedValue(value: any) {
    if (value !== undefined) {
      // Es necesario un timeout de 0 para que se cierre el ciclo y el componente exista como view children en el padre
      setTimeout(() => this.onFilterChange(value), 0);
    }
  }

  showChip = false;
  selectedTextValue = '';

  constructor() {}

  ngOnChanges() {
  }

  onFilterChange(selectedValue: any) {

  }

  onRemoveChip() {
    this.showChip = false;
  }

  apply() {
    this.showChip = true;
    const fechaFormateada = moment(this.filterValue.displayText).format('DD/MM/YYYY');
    this.filterChangeEvent.emit({
      value: fechaFormateada, categoryName: this.categoryName, viewValue: fechaFormateada});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/expansor-with-search-date/expansor-with-search-date.component.ts